import React, { forwardRef, useState } from "react";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

// Password box with an eye button to show / hide what was typed. Takes the same props as <input>
// (so it works with react-hook-form's {...register("password")}); `style` styles the input itself.
const PasswordInput = forwardRef(function PasswordInput({ style, ...props }, ref) {
  const [visible, setVisible] = useState(false);
  return (
    <div style={{ position: "relative", display: "flex", width: "100%" }}>
      <input
        {...props}
        ref={ref}
        type={visible ? "text" : "password"}
        style={{ ...style, width: "100%", boxSizing: "border-box", paddingRight: 42 }}
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? "Hide password" : "Show password"}
        title={visible ? "Hide password" : "Show password"}
        tabIndex={-1}
        style={{
          position: "absolute", right: 6, top: "50%", transform: "translateY(-50%)",
          background: "none", border: "none", cursor: "pointer", padding: 4, color: "#64748B",
          display: "flex", alignItems: "center",
        }}
      >
        {visible ? <VisibilityOff style={{ fontSize: 20 }} /> : <Visibility style={{ fontSize: 20 }} />}
      </button>
    </div>
  );
});

export default PasswordInput;
